<template>
  <v-navigation-drawer
    color="secondary"
    fixed
    app
    :value="navbarShow"
    @input="stateNavbarShow"
  >

    <v-app-bar>
      <v-container>
        <v-row class="d-flex justify-space-between">
          <v-avatar
            class="logo-avatar"
            size="50px"
            tile
          >
            <img
              src="@/assets/logo.svg"
              alt="logo"
            >
          </v-avatar>
        </v-row>
      </v-container>
      
    </v-app-bar>
    <layout-drawer-list/>
  </v-navigation-drawer>
</template>

<script>
  import LayoutDrawerList from '@/components/layout/LayoutDrawerList';
  import {mapGetters} from 'vuex';
  import * as actions from '../../store/actions.type';

  export default {
    name: 'LayoutDrawer',
    components: {
      LayoutDrawerList,
    },
    computed: {
      ...mapGetters([
        'navbarShow',
      ]),
    },
    methods: {
      stateNavbarShow(state) {
        this.$store.dispatch(actions.NAVBAR_STATE, {state});
      },
    },
  };
</script>
